import { render } from "./DetailPage.vue?vue&type=template&id=3cdd4bde"
import script from "./DetailPage.vue?vue&type=script&lang=js"
export * from "./DetailPage.vue?vue&type=script&lang=js"

import "./DetailPage.vue?vue&type=style&index=0&id=3cdd4bde&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__